import React from "react";
import { Link } from "react-router-dom";
import SiteLayout from "../components/SiteLayout";
import { CASE_STUDIES } from "../data/staticData";
import { ArrowUpRight } from "lucide-react";
import CTASection from "../components/sections/CTASection";

export default function CaseStudies() {
  return (
    <SiteLayout>
      <section className="pt-20 pb-12">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 max-w-3xl">
          <div className="eyebrow mb-4">Case studies</div>
          <h1 className="font-display text-5xl sm:text-6xl font-bold tracking-tight">Real campaigns. Real metrics.</h1>
          <p className="mt-6 text-inkSoft text-lg">A look at the structure, services, and results behind some of our favorite engagements — from steady link building programmes to one-off PR launches.</p>
        </div>
      </section>

      <section className="py-12">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 grid grid-cols-1 md:grid-cols-2 gap-6">
          {CASE_STUDIES.map((c, i) => (
            <Link
              key={c.slug}
              to={`/case-studies/${c.slug}`}
              className={`card-soft overflow-hidden block group ${i === 0 ? "md:col-span-2" : ""}`}
              data-testid={`case-card-${c.slug}`}
            >
              <div className="grid md:grid-cols-2">
                <div className="aspect-[4/3] md:aspect-auto bg-surfaceAlt overflow-hidden">
                  <img src={c.image} alt={c.title} className="w-full h-full object-cover group-hover:scale-105 transition duration-700" />
                </div>
                <div className="p-7">
                  <div className="flex items-center gap-2 mb-4">
                    <span className="tag">{c.industry}</span>
                  </div>
                  <h2 className="font-display text-2xl font-bold tracking-tight group-hover:text-terra transition">{c.title}</h2>
                  <p className="mt-3 text-sm text-inkSoft leading-relaxed line-clamp-3">{c.challenge}</p>
                  <div className="grid grid-cols-3 gap-3 mt-6">
                    {c.metrics.map((m) => (
                      <div key={m.label} className="border-l border-line pl-3">
                        <div className="font-mono text-xl font-semibold tracking-tighter">{m.delta}</div>
                        <div className="text-[11px] uppercase tracking-widest text-inkSoft mt-1">{m.label}</div>
                      </div>
                    ))}
                  </div>
                  <div className="mt-6 inline-flex items-center gap-1 text-sm text-terra font-medium">
                    Read case study <ArrowUpRight size={14} />
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </section>
      <CTASection />
    </SiteLayout>
  );
}
